var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16683 0.200196C1.03865 0.0720126 0.864792 0 0.683513 0C0.502234 0 0.32838 0.0720126 0.200196 0.200196C0.0720126 0.32838 0 0.502234 0 0.683513C0 0.864792 0.0720126 1.03865 0.200196 1.16683L5.03337 6L0.200196 10.8332C0.0720126 10.9614 0 11.1352 0 11.3165C0 11.4978 0.0720126 11.6716 0.200196 11.7998C0.32838 11.928 0.502234 12 0.683513 12C0.864792 12 1.03865 11.928 1.16683 11.7998L6 6.96663L10.8332 11.7998C10.9614 11.928 11.1352 12 11.3165 12C11.4978 12 11.6716 11.928 11.7998 11.7998C11.928 11.6716 12 11.4978 12 11.3165C12 11.1352 11.928 10.9614 11.7998 10.8332L6.96663 6L11.7997 1.1669C11.9279 1.03872 11.9999 0.864866 11.9999 0.683587C11.9999 0.502308 11.9279 0.328454 11.7997 0.20027C11.6715 0.0720864 11.4977 7.32874e-05 11.3164 7.32874e-05C11.1351 7.32874e-05 10.9613 0.0720864 10.8331 0.20027L6 5.03337L1.16683 0.200196Z",
    fill: "#070707"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/CloseIcon.d1e3110decf14e93e3d575940078733b.svg";
export { ForwardRef as ReactComponent };